import {EntityResourceIds} from '@dms/api/shared';
import {featureFlags} from '@dms/feature-flags';
import {ActivitySidebarAction, ActivitySidebarV2} from '@dms/features/activity-panel';
import {buildCustomNoticesSidebarAction} from '@dms/features/custom-notices';

import {buildArray} from 'shared/web';

interface CustomerActivityPanelProps {
  customerId: string;
}

export function CustomerActivityPanel(props: CustomerActivityPanelProps) {
  const actions = buildArray<ActivitySidebarAction>().whenFeatureEnabled(
    featureFlags.CUSTOM_NOTICES,
    buildCustomNoticesSidebarAction({
      resourceId: EntityResourceIds.customer,
      recordId: props.customerId,
    })
  );

  return <ActivitySidebarV2 actions={actions} />;
}
